import React, { useEffect, useState } from "react";

function App() {
  const [blacklist, setBlacklist] = useState([]);

  useEffect(() => {
    fetch("/blacklist_log.json")
    .then((res) => res.json())
    .then((data) => setBlacklist(data))
    .catch((err) => console.error("Failed to fetch blacklist:", err));
  }, []);

  return (
    <div style={{ backgroundColor: "#111", minHeight: "100vh", padding: "2rem" }}>
    <h1 style={{ color: "#ff4444", textAlign: "center", marginBottom: "2rem" }}>
    Divine Blacklist Memory
    </h1>
    <table
    style={{
      width: "90vw",
      margin: "0 auto",
      borderCollapse: "collapse",
      color: "#ff4444",
      backgroundColor: "#111",
      border: "2px solid #660000",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    }}
    >
    <thead>
    <tr style={{ backgroundColor: "#330000", color: "#ff6666" }}>
    <th style={{ padding: "1rem", border: "1px solid #660000", textTransform: "uppercase", letterSpacing: "0.05em" }}>Name</th>
    <th style={{ padding: "1rem", border: "1px solid #660000", textTransform: "uppercase", letterSpacing: "0.05em" }}>Reason</th>
    <th style={{ padding: "1rem", border: "1px solid #660000", textTransform: "uppercase", letterSpacing: "0.05em" }}>Evidence</th>
    <th style={{ padding: "1rem", border: "1px solid #660000", textTransform: "uppercase", letterSpacing: "0.05em" }}>Level</th>
    <th style={{ padding: "1rem", border: "1px solid #660000", textTransform: "uppercase", letterSpacing: "0.05em" }}>Timestamp (UTC)</th>
    </tr>
    </thead>
    <tbody>
    {blacklist.map((entry, idx) => (
      <tr
      key={idx}
      style={{ backgroundColor: idx % 2 === 0 ? "#220000" : "transparent" }}
      >
      <td style={{ padding: "1rem", border: "1px solid #660000" }}>{entry.name}</td>
      <td style={{ padding: "1rem", border: "1px solid #660000" }}>{entry.reason}</td>
      <td
      style={{
        padding: "1rem",
        border: "1px solid #660000",
        color: "#ff5555",
        fontWeight: "bold",
        wordBreak: "break-all",
      }}
      >
      <a
      href={entry.evidence_url}
      target="_blank"
      rel="noreferrer"
      style={{ color: "#ff8888", textDecoration: "underline" }}
      >
      {entry.evidence_url}
      </a>
      </td>
      <td style={{ padding: "1rem", border: "1px solid #660000" }}>{entry.level}</td>
      <td style={{ padding: "1rem", border: "1px solid #660000" }}>{entry.timestamp}</td>
      </tr>
    ))}
    </tbody>
    </table>
    </div>
  );
}

export default App;
